var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColor24Overview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(1.051 1.1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#9AAAB4",
    points: "16.217 14.537 14.538 16.217 11.597 13.276 13.277 11.597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M20.550618,17.190954 L17.058492,13.698828 C16.594578,13.234914 15.842574,13.234914 15.37866,13.698828 L13.698828,15.37866 C13.234914,15.842574 13.234914,16.594578 13.698828,17.058492 L17.190954,20.550618 C18.118782,21.47904 19.623978,21.47904 20.551806,20.550618 C21.478446,19.623384 21.477852,18.118782 20.550618,17.190954 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.019,
    cy: 8.019,
    r: 8.019,
    fill: "#8899A6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.019,
    cy: 8.019,
    r: 5.643,
    fill: "#BBDDF5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor24Overview);
export default __webpack_public_path__ + "static/media/color24-overview.d67c32ee.svg";
export { ForwardRef as ReactComponent };